import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CalendarClock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import SocialAuthButtons from "@/components/SocialAuthButtons";
import { trackMetaEventOnce } from "@/lib/metaPixel";
import { trackOaiqRegistration } from "@/lib/oaiqPixel";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const billing = searchParams.get("billing");
  const [form, setForm] = useState({ business_name: "", name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      trackMetaEventOnce("CompleteRegistration", undefined, form.email);
      trackOaiqRegistration(form.email);
      toast.success("İşletmeniz oluşturuldu!");
      nav(billing === "yearly" ? "/panel/abonelik?billing=yearly" : billing === "monthly" ? "/panel/abonelik?billing=monthly" : "/panel");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grain-bg flex items-center justify-center p-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center">
            <CalendarClock className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="font-display font-bold text-2xl">365Rez</span>
        </Link>
        <div className="rounded-xl border border-border bg-card p-8 shadow-sm">
          <h1 className="text-2xl font-bold mb-1">İşletme Oluştur</h1>
          <p className="text-sm text-muted-foreground mb-6">Ücretsiz hesabınızı oluşturun</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="bn">İşletme Adı</Label>
              <Input id="bn" value={form.business_name} onChange={set("business_name")} required
                className="h-12 mt-1.5" placeholder="Kuaför Elite" data-testid="register-business-input" />
            </div>
            <div>
              <Label htmlFor="n">Ad Soyad</Label>
              <Input id="n" value={form.name} onChange={set("name")} required
                className="h-12 mt-1.5" placeholder="Ali Yılmaz" data-testid="register-name-input" />
            </div>
            <div>
              <Label htmlFor="ph">İşletme Telefonu</Label>
              <Input id="ph" type="tel" value={form.phone} onChange={set("phone")} required
                className="h-12 mt-1.5" placeholder="05XX XXX XX XX" data-testid="register-phone-input" />
            </div>
            <div>
              <Label htmlFor="e">E-posta</Label>
              <Input id="e" type="email" value={form.email} onChange={set("email")} required
                className="h-12 mt-1.5" placeholder="ornek@isletme.com" data-testid="register-email-input" />
            </div>
            <div>
              <Label htmlFor="p">Şifre</Label>
              <Input id="p" type="password" value={form.password} onChange={set("password")} required minLength={6}
                className="h-12 mt-1.5" placeholder="En az 6 karakter" data-testid="register-password-input" />
            </div>
            <Button type="submit" className="w-full h-12 rounded-lg" disabled={loading} data-testid="register-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Hesap Oluştur"}
            </Button>
          </form>
          <SocialAuthButtons />
          <p className="text-sm text-center text-muted-foreground mt-6">
            Zaten hesabınız var mı?{" "}
            <Link to="/giris" className="text-primary font-semibold hover:underline">Giriş yapın</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
